import { createElement } from 'react'
import { fontSize } from '@offerzen/pinata-shame'

/**
 * AccessibleIcon component
 *
 * @param {Object} props
 * @param {(Object|JSX.Element)} props.icon
 * @param {string} [props.title]
 * @param {(string|number)} [props.size]
 * @param {string} [props.color]
 * @param {string} [props.className]
 * @param {boolean} [props.ariaHidden]
 *
 * @returns {JSX.Element}
 */
const AccessibleIcon = ({ icon, title, size = fontSize.medium, color, className, ariaHidden = false }) =>
  createElement(icon, {
    title: !ariaHidden && title,
    fontSize: size,
    color,
    className,
    'aria-hidden': (!title && 'true') || ariaHidden.toString(),
  })

export default AccessibleIcon
